let lastId = 0

export const uniqueId = () => {
  lastId++
  return lastId
}